"use client";
import { theme } from "@/theme";
import { useMediaQuery } from "@khol/components/hooks";
import YoutubeSvg from "./assets/youtube.svg";

const CFooter = () => {
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.md);
  const fullYear = new Date().getFullYear();
  if (isTabletOrMobile) return null;
  return (
    <footer className="z-40 fixed bottom-0 bg-background shadow-lg w-full border-t-default-200 border-t-1">
      <div className="w-full p-4 md:flex justify-between">
        <span className="text-sm sm:text-center">
          © {fullYear} <span className="font-bold">Youlli™</span>. All Rights
          Reserved.
        </span>
        <ul className="flex flex-wrap items-center mt-3 text-sm font-medium sm:mt-0">
          <li>
            <a
              href="https://www.youtube.com/@yyoulli2653"
              className="mr-4 hover:underline md:mr-6 flex items-center"
            >
              <YoutubeSvg className="text-danger" />
              Youtube
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default CFooter;
